// extracted by mini-css-extract-plugin
module.exports = {"btn":"styles_btn__5Nvry","btnlight":"styles_btnlight__anRh_","btndark":"styles_btndark__YNezc"};